import api from "./index";

export async function signIn(body) {
  return api.post("/auth/local/admin", body);
}

export async function loadSession() {
  return api.get("/auth");
}
